import React from 'react';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormRadioGroup } from 'components/molecules/FormRadioGroup';
import Button from 'components/atoms/Button';
import {
  StyledPaymentWrapper,
  StyledPaymentInfoWrapper,
  StyledPaymentDetailsWrapper,
} from './styles';

enum EPaymentType {
  BANK_TRANSFER = 'BANK_TRANSFER',
  PAY_ONLINE = 'PAY_ONLINE',
}

export interface IPaymentStepFormValues {
  paymentType: EPaymentType;
}

export const initialPaymentStepFormValues: IPaymentStepFormValues = {
  paymentType: EPaymentType.BANK_TRANSFER,
};

const PaymentStep = () => {
  const {
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: initialPaymentStepFormValues,
  });

  const watchPaymentType = watch('paymentType');

  return (
    <StyledPaymentWrapper container xs={12} alignItems="center" columnGap="20px">
      <Grid item xs={12}>
        <Typography variant="h5">Payment</Typography>
      </Grid>

      <form>
        <FormRadioGroup
          name="paymentType"
          label="Payment Type"
          options={[
            { label: 'Bank Transfer', value: EPaymentType.BANK_TRANSFER },
            { label: 'Pay Online', value: EPaymentType.PAY_ONLINE },
          ]}
          control={control}
          errors={errors}
        />
      </form>

      <StyledPaymentInfoWrapper item xs={12}>
        <div>
          <Typography variant="subtitle2">
            Licence Name: <span>Certificate to Possess a Shotgun</span>
          </Typography>
        </div>
        <div>
          <Typography variant="subtitle2">
            Total Fee: <span>125 GBP</span>
          </Typography>
        </div>
      </StyledPaymentInfoWrapper>

      {watchPaymentType === EPaymentType.BANK_TRANSFER ? (
        <>
          <StyledPaymentDetailsWrapper item xs={12}>
            <Typography variant="h5">Payment Data</Typography>

            <div>
              <Typography variant="subtitle2">
                Recipient: <span>Faucibus ac id quisque ac diam et lacus</span>
              </Typography>
            </div>
            <div>
              <Typography variant="subtitle2">
                Recipient Address: <span>41685 Cody Walks, Edina 92254-6670</span>
              </Typography>
            </div>
            <div>
              <Typography variant="subtitle2">
                Account Number: <span>00 0000 0000 0000 0000 0000 00</span>
              </Typography>
            </div>
            <div>
              <Typography variant="subtitle2">
                Amount: <span>125,00 GBP</span>
              </Typography>
            </div>
            <div>
              <Typography variant="subtitle2">
                Title: <span>Licence Fee</span>
              </Typography>
            </div>
          </StyledPaymentDetailsWrapper>

          <Grid item xs={6}>
            <Button label="Generate Payment Slip" fullWidth />
          </Grid>
        </>
      ) : (
        <>
          <StyledPaymentDetailsWrapper item xs={12}>
            <Typography variant="subtitle1">
              You will be redirected to the payment provider to process the payment.
            </Typography>
          </StyledPaymentDetailsWrapper>
          <Grid item xs={6}>
            <Button label="Pay Now" fullWidth />
          </Grid>
        </>
      )}
    </StyledPaymentWrapper>
  );
};

export default PaymentStep;
